import { createFileRoute } from '@tanstack/react-router';
import { DocumentView } from '@/components/documents/DocumentView.tsx';
import { ErrorBoundary } from '@/components/ErrorBoundary.tsx';

export const Route = createFileRoute('/$spaceSlug/documents/$docId')({
  validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
    tab: typeof search.tab === 'string' ? search.tab : undefined,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { docId } = Route.useParams();

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <ErrorBoundary resetKey={`document-view-${docId}`}>
        <DocumentView id={docId} />
      </ErrorBoundary>
    </div>
  );
}
